module.exports = __webpack_public_path__ + "img/cpjs_bg.df3d57d0.png";